import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export interface SuggestionProduct {
    id: string;
    slug: string;
    name: string;
    price: number;
    compareAtPrice: number | null;
    image: string | null;
}

export interface SuggestionCategory {
    id: string;
    slug: string;
    name: string;
    image: string | null;
}

export interface SuggestionBrand {
    id: string;
    slug: string;
    name: string;
    image: string | null;
}

export interface SearchSuggestionsResponse {
    products: SuggestionProduct[];
    categories: SuggestionCategory[];
    brands: SuggestionBrand[];
}

export const useSearchSuggestions = (query: string) => {
    return useQuery<SearchSuggestionsResponse>({
        queryKey: ['search-suggestions', query],
        queryFn: async ({ signal }) => {
            const res = await api.get(`/products/suggest?q=${encodeURIComponent(query)}&limit=5`, { signal });
            return res.data.data;
        },
        enabled: query.length >= 2,
        staleTime: 60 * 1000, // 1 minute
        gcTime: 5 * 60 * 1000, // 5 minutes
    });
};
